import axios from "axios";
const { REACT_APP_API_SEARCH } = process.env;

export const getFilteredData = async (
  term: string,
  payload: any,
  facet: string | null
) => {
  try {
    const res = await axios.post(
      `${REACT_APP_API_SEARCH}/GetDocuments?searchTerm=${term}&selectedFacet=${facet}`,
      payload
    );
    return res;
  } catch (error) {
    console.error("[getFilteredData]: ", error);
  }
};

export const getSuggestions = async (term: string) => {
  try {
    const res = await axios.get(
      `${REACT_APP_API_SEARCH}/GetACWithSearchSuggestions?searchText=${term}&numSuggestions=25`
    );
    return res;
  } catch (error) {
    console.error("[getFilteredData]: ", error);
  }
};

export const getProducts = async (term: string) => {
  try {
    const res = await axios.get(
      `${REACT_APP_API_SEARCH}/GetSearchDocuments?searchText=${term}`
    );
    return res;
  } catch (error) {
    console.error("[getFilteredData]: ", error);
  }
};

export const getSearchData = async (term: string) => {
  try {
    const res = await axios.get(
      `${REACT_APP_API_SEARCH}/GetFacetsWithSearch?searchText=${term}`
    );
    return res;
  } catch (error) {
    console.error("[getFilteredData]: ", error);
  }
};
